export default __webpack_public_path__ + "static/media/insppvServicesrealestate.dcd52fa7.svg";